import styled from "styled-components";

export const MainContainer = styled.div`
  /* margin: 10px 10px; */
  flex-grow: 1; /* Allow the main content to grow */
  display: flex;
  flex-direction: column;
  margin-bottom: 100px;
  @media (max-width: 768px) {
    /* margin: 10px 10px; */
  }

  @media (min-width: 769px) {
    /* margin: 10px 10px; */
  }
`;

export const OuterContainer = styled.div`
  display: flex;
  /* flex-direction: column; */
  min-height: 100vh; /* Ensures the container takes full height */
`;